/** Allowed forward/sideways status moves for assessment ops. Same status is always allowed. */
export const ASSESSMENT_STATUS_TRANSITIONS = {
    request_received: ['under_review', 'cancelled'],
    under_review: ['consultation_scheduled', 'cancelled'],
    consultation_scheduled: ['assessment_proposed', 'under_review', 'cancelled'],
    assessment_proposed: ['awaiting_approval', 'under_review', 'cancelled'],
    awaiting_approval: ['assessment_scheduled', 'assessment_proposed', 'cancelled'],
    assessment_scheduled: ['in_progress', 'cancelled'],
    in_progress: ['feedback_pending', 'cancelled'],
    feedback_pending: ['completed', 'cancelled'],
    completed: [],
    cancelled: ['under_review'],
};
export function canTransitionAssessmentStatus(from, to) {
    if (from === to)
        return true;
    return ASSESSMENT_STATUS_TRANSITIONS[from].includes(to);
}
export function nextAssessmentStatuses(from) {
    return [from, ...ASSESSMENT_STATUS_TRANSITIONS[from]];
}
export const ASSESSMENT_STATUS_HINTS = {
    request_received: 'Review the enquiry and move it under review.',
    under_review: 'Set the consultation fee and schedule the initial consultation.',
    consultation_scheduled: 'After consultation, issue the full assessment quotation.',
    assessment_proposed: 'Send the quote for client approval (awaiting approval).',
    awaiting_approval: 'Record client approval, then schedule the assessment.',
    assessment_scheduled: 'Mark in progress when the assessment work begins.',
    in_progress: 'When instruments and review are done, move to feedback pending.',
    feedback_pending: 'Complete after feedback and any agreed report delivery.',
    completed: 'Terminal — enquiry closed.',
    cancelled: 'Reopen to under review only if the client returns.',
};
//# sourceMappingURL=assessmentEnquiries.js.map